module.exports = __webpack_public_path__ + "static/img/10.1938ab1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/10.png
// module id = i8gr
// module chunks = 0